// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; // IMPORT NAVIGATE
// import Navbar from "../components/common/Navbar";
// import Footer from "../components/common/Footer";
// import ScrollReveal from "../components/common/ScrollReveal";
// import styles from "./ProductsPage.module.css";
// import wholesaleImage from "../assets/Products/wholesale-1.jpg";

// const ProductCard = ({ product, index }) => {
//   const navigate = useNavigate(); // INITIALIZE NAVIGATE

//   const isButtonDisabled = !product.price || product.price === 0;

//   // Navigate to Detail Page instead of direct add-to-cart
//   const handleViewDetail = () => {
//     if (isButtonDisabled) return;
//     navigate(`/products/${product._id}`);
//   };

//   return (
//     <ScrollReveal className={styles.productCard} delay={index * 0.1}>
//       <div
//         className={styles.productImageContainer}
//         onClick={handleViewDetail}
//         style={{ cursor: "pointer" }}
//       >
//         {product.imageURL ? (
//           <img src={`${product.imageURL}`} alt={product.name} />
//         ) : (
//           <div className={styles.noImagePlaceholder}>No Image</div>
//         )}
//       </div>
//       <div className={styles.productInfo}>
//         <h3 onClick={handleViewDetail} style={{ cursor: "pointer" }}>
//           {product.name}
//         </h3>

//         {product.minQuantity > 1 && (
//           <span className={styles.minOrderText}>
//             Min Order: {product.minQuantity}
//           </span>
//         )}

//         <button
//           className={styles.buyProductBtn}
//           onClick={handleViewDetail}
//           disabled={isButtonDisabled}
//         >
//           {isButtonDisabled ? "Unavailable" : "Buy Now"}
//         </button>
//         <div className={styles.productPrice}>
//           <span className={styles.priceValue}>
//             {isButtonDisabled
//               ? "N/A"
//               : `${product.price.toLocaleString("en-US")} Br`}
//           </span>
//           {product.description && (
//             <span className={styles.priceDescription}>
//               {product.description}
//             </span>
//           )}
//         </div>
//       </div>
//     </ScrollReveal>
//   );
// };

// function ProductsPage() {
//   const [products, setProducts] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const fetchProducts = async () => {
//       try {
//         setIsLoading(true);
//         const response = await fetch("/api/cms/products");
//         if (!response.ok) throw new Error("Failed to fetch products.");
//         const data = await response.json();
//         const productItemsOnly = data.filter(
//           (p) => p.category?.type === "Product",
//         );
//         setProducts(productItemsOnly);
//       } catch (error) {
//         console.error(error);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchProducts();
//   }, []);

//   const groupedProducts = products.reduce((groups, product) => {
//     const categoryName = product.category?.name || "Uncategorized";
//     if (!groups[categoryName]) groups[categoryName] = [];
//     groups[categoryName].push(product);
//     return groups;
//   }, {});

//   const preferredOrder = [
//     "Roasted Coffee",
//     "Brewing Equipments",
//     "Merch & Books",
//   ];
//   const sortedCategoryNames = Object.keys(groupedProducts).sort((a, b) => {
//     const indexA = preferredOrder.indexOf(a);
//     const indexB = preferredOrder.indexOf(b);
//     if (indexA !== -1 && indexB !== -1) return indexA - indexB;
//     if (indexA !== -1) return -1;
//     if (indexB !== -1) return 1;
//     return a.localeCompare(b);
//   });

//   return (
//     <div className={styles.productsPage}>
//       <Navbar />
//       <div className={styles.productsHero}>
//         <h1>Products</h1>
//       </div>

//       {!isLoading && (
//         <>
//           {sortedCategoryNames.map((categoryName) => {
//             const categoryProducts = groupedProducts[categoryName];
//             const gridClass =
//               categoryName === "Roasted Coffee" ? "grid32Col" : "grid4Col";
//             return (
//               <section className={styles.productsSection} key={categoryName}>
//                 <h2>{categoryName}</h2>
//                 <div className={`${styles.productsGrid} ${styles[gridClass]}`}>
//                   {categoryProducts.map((product, index) => (
//                     <ProductCard
//                       product={product}
//                       key={product._id}
//                       index={index}
//                     />
//                   ))}
//                 </div>
//               </section>
//             );
//           })}
//         </>
//       )}

//       <ScrollReveal>
//         <section
//           className={`${styles.productsSection} ${styles.wholesaleSection}`}
//         >
//           <h2>Wholesales</h2>
//           <div className={styles.wholesaleContent}>
//             <div className={styles.wholesaleImageContainer}>
//               <img src={wholesaleImage} alt="Wholesale coffee" />
//             </div>
//             <div className={styles.wholesaleText}>
//               <p>
//                 We are proud to partner with businesses by offering premium
//                 wholesale coffee services tailored to meet your unique needs.
//               </p>
//               <p className={styles.wholesaleContactInfo}>
//                 For Wholesale service call <br />
//                 <span>(+251)92-422-22-00</span>
//               </p>
//               <h4>
//                 Partner with us for wholesale services that deliver exceptional
//                 flavor and quality every time
//               </h4>
//             </div>
//           </div>
//         </section>
//       </ScrollReveal>
//       <Footer />
//     </div>
//   );
// }

// export default ProductsPage;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import ScrollReveal from "../components/common/ScrollReveal";
import styles from "./ProductsPage.module.css";
import wholesaleImage from "../assets/Products/wholesale-1.jpg";

const ProductCard = ({ product, index }) => {
  const navigate = useNavigate();

  // 💎 FIX: Convert the price to a real number first to catch "0" strings
  const numericPrice = parseFloat(product.price);
  const isButtonDisabled =
    !product.price || isNaN(numericPrice) || numericPrice <= 0;

  const handleViewDetail = () => {
    if (isButtonDisabled) return;
    navigate(`/products/${product._id}`);
  };

  return (
    <ScrollReveal className={styles.productCard} delay={index * 0.1}>
      <div
        className={styles.productImageContainer}
        onClick={handleViewDetail}
        style={{ cursor: "pointer" }}
      >
        {product.imageURL ? (
          <img src={`${product.imageURL}`} alt={product.name} />
        ) : (
          <div className={styles.noImagePlaceholder}>No Image</div>
        )}
      </div>
      <div className={styles.productInfo}>
        <h3 onClick={handleViewDetail} style={{ cursor: "pointer" }}>
          {product.name}
        </h3>

        {product.minQuantity > 1 && (
          <span className={styles.minOrderText}>
            Min Order: {product.minQuantity}
          </span>
        )}

        <button
          className={styles.buyProductBtn}
          onClick={handleViewDetail}
          disabled={isButtonDisabled}
        >
          {isButtonDisabled ? "Unavailable" : "Buy Now"}
        </button>
        <div className={styles.productPrice}>
          <span className={styles.priceValue}>
            {/* 💎 DYNAMIC CURRENCY: Uses symbol from backend instead of hardcoded "Br" */}
            {isButtonDisabled
              ? "N/A"
              : `${product.currencySymbol || "Br"} ${parseFloat(product.price || 0).toLocaleString("en-US")}`}
          </span>
          {product.description && (
            <span className={styles.priceDescription}>
              {product.description}
            </span>
          )}
        </div>
      </div>
    </ScrollReveal>
  );
};

function ProductsPage() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchProducts = async () => {
      try {
        setIsLoading(true);
        const response = await fetch("/api/cms/products");
        if (!response.ok) throw new Error("Failed to fetch products.");
        const data = await response.json();
        const productItemsOnly = data.filter(
          (p) => p.category?.type === "Product",
        );
        setProducts(productItemsOnly);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const groupedProducts = products.reduce((groups, product) => {
    const categoryName = product.category?.name || "Uncategorized";
    if (!groups[categoryName]) groups[categoryName] = [];
    groups[categoryName].push(product);
    return groups;
  }, {});

  const preferredOrder = [
    "Roasted Coffee",
    "Brewing Equipments",
    "Merch & Books",
  ];
  const sortedCategoryNames = Object.keys(groupedProducts).sort((a, b) => {
    const indexA = preferredOrder.indexOf(a);
    const indexB = preferredOrder.indexOf(b);
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.localeCompare(b);
  });

  return (
    <div className={styles.productsPage}>
      <Navbar />
      <div className={styles.productsHero}>
        {/* 💎 HERE IS THE SANITY CHECK 💎 */}
        <h1>Products</h1>
      </div>

      {!isLoading && (
        <>
          {sortedCategoryNames.map((categoryName) => {
            const categoryProducts = groupedProducts[categoryName];
            const gridClass =
              categoryName === "Roasted Coffee" ? "grid32Col" : "grid4Col";
            return (
              <section className={styles.productsSection} key={categoryName}>
                <h2>{categoryName}</h2>
                <div className={`${styles.productsGrid} ${styles[gridClass]}`}>
                  {categoryProducts.map((product, index) => (
                    <ProductCard
                      product={product}
                      key={product._id}
                      index={index}
                    />
                  ))}
                </div>
              </section>
            );
          })}
        </>
      )}

      <ScrollReveal>
        <section
          className={`${styles.productsSection} ${styles.wholesaleSection}`}
        >
          <h2>Wholesales</h2>
          <div className={styles.wholesaleContent}>
            <div className={styles.wholesaleImageContainer}>
              <img src={wholesaleImage} alt="Wholesale coffee" />
            </div>
            <div className={styles.wholesaleText}>
              <p>
                We are proud to partner with businesses by offering premium
                wholesale coffee services tailored to meet your unique needs.
              </p>
              <p className={styles.wholesaleContactInfo}>
                For Wholesale service call <br />
                <span>(+251)92-422-22-00</span>
              </p>
              <h4>
                Partner with us for wholesale services that deliver exceptional
                flavor and quality every time
              </h4>
            </div>
          </div>
        </section>
      </ScrollReveal>
      <Footer />
    </div>
  );
}

export default ProductsPage;